/**
 * node_modules
 */
import { graphql, useStaticQuery } from "gatsby"

/**
 * Modules
 */
import { Hero } from "@features/Home/Hero"
import { Map } from "@features/Home/Map"
import { CampSection } from "@features/Home/CampSection"
import { Business } from "@features/Home/Business"
import { Outro } from "@features/Home/Outro"
import { EventSlider } from "@src/components/EventSlider"
import { sortEvents } from "@features/Events/Pickup"

/**
 * @function Home
 * @description HOMEコンテンツ
 */
export const Home = () => {
  const data: Queries.HomeEventSliderItemsQuery = useStaticQuery(graphql`
    query HomeEventSliderItems {
      camp {
        events {
          assemblyAt
          assemblyLocation
          body
          description
          dressCode
          displayLocation
          estimatedTime
          eventSchedules {
            startAt
            endAt
          }
          eventType
          id
          images {
            url
            alt
          }
          location
          pickup
          title
          sortOrder
          sortOrderAll
        }
      }
    }
  `)
  const { events } = data.camp
  // 並び替え、ピックアップフラグのついた項目のフィルタ、リミットの設定
  const pickupEvents = sortEvents(events, "sortOrderAll")
    .filter((event) => event.pickup)
    .slice(0, 9)

  return (
    <main>
      <Hero />

      <EventSlider events={pickupEvents} />

      <Map />

      <CampSection />

      <Business />
      <Outro />
    </main>
  )
}
